// @flow
import { styled } from 'goober';
import { useState, useEffect } from 'preact/hooks';
import MuiInput from '../material-ui/muiInput';
import SaCustomButton from './SaCustomButton';
import { validateEmail } from '../../utils/stringOperations';
import { useSalesAppTracker } from './tracker';
import useKeyEnter from '../../hooks/useKeyEnter';

const ShareNtbAppContainer = styled('div')`
  .container {
    padding: 50px 16px 30px 16px;
  }
  .heading {
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    display: flex;
    align-items: center;
    color: var(--primaryCTAColor);
    padding-bottom: 16px;
  }
  .subHeading {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.2px;
    color: #333333;
    padding-bottom: 32px;
  }
`;
const BtnContainerSection = styled('div')`
  .btnContainer {
    margin: 45px 0px 0px;
    display: flex;
    justify-content: center;
  }
`;
const LabelContainer = styled('div')`
  padding: 14px 0px 0px 0px;
  .mdc-text-field--outlined .mdc-floating-label {
    border-color: #000000;
  }
  .fullNamePlaceholder {
    position: absolute;
    z-index: 1;
    display: inline-block;
    height: 30px;
    padding: 4px 4px 0px 15px;
    width: auto;
    text-align: center;
    top: 11px;
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    letter-spacing: 0.1px;
    color: #d8d8d8;
    margin-left: 5px;
  }
  .fullNameWrapper {
    position: relative;
  }
  .fullNameWrapper input {
    text-align: left !important;
    padding-left: 20px !important;
  }
  .emailPlaceholder {
    position: absolute;
    z-index: 1;
    display: inline-block;
    height: 30px;
    padding: 4px 4px 0px 15px;
    width: auto;
    text-align: center;
    top: 11px;
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    letter-spacing: 0.1px;
    color: #d8d8d8;
    margin-left: 6px;
  }
  .emailWrapper {
    position: relative;
  }
  .errorText {
    color: #b00020;
    font-size: 12px;
    margin-top: 10px;
  }
  .emailWrapper input {
    text-align: left !important;
    padding-left: 20px !important;
  }
`;
const ShareNtbApp = ({ handleBtnClickForNtbApp, btnTxt, loading }) => {
  const pageKey = 'sa_pv_ntb_application_share_modal';
  const checkOnlyLettersAndSpacesRegex = /[^a-zA-Z ]/g;
  const [fullName, changeFullName] = useState({ name: '' });
  const salesAppTracker = useSalesAppTracker(pageKey);
  const [fullNamePlaceholder, changeFullNamePlaceholder] = useState(
    'John Snow',
  );
  const [email, changeEmail] = useState('');
  const [emailPlaceholder, changeEmailPlaceholder] = useState(
    'johnSnow@gmail.com',
  );
  const [prefixForName, showPrefixForName] = useState(false);
  const [prefixForEmail, showPrefixForEmail] = useState(false);
  const [emailError, setEmailError] = useState(false);

  const handleSubmitNtb = () => {
    if (email.trim() !== '' && !validateEmail(email))
      return setEmailError(true);

    handleBtnClickForNtbApp(email, fullName.name.trim());
  };
  useEffect(() => {
    salesAppTracker.trackPageView('sa_pv_ntb_application_share_modal');
  }, []);

  useKeyEnter(() => {
    if (fullName.name.trim() !== '') {
      handleSubmitNtb();
    }
  });

  return (
    <ShareNtbAppContainer>
      <div className='container'>
        <div className='heading'>
          Enter customer's details to share application link for new credit line
        </div>

        <LabelContainer>
          <div className='subHeading'>Customer's Name</div>
          <div className='fullNameWrapper'>
            {prefixForName && (
              <span className='fullNamePlaceholder'>{fullNamePlaceholder}</span>
            )}
            <MuiInput
              className='mdc-text-field--focused'
              label='Full Name'
              outlined
              autoFocus={true}
              inputType='text'
              inputName='fullName'
              inputID='fullName'
              elementName='Full Name'
              maxLength={40}
              inputValue={fullName.name}
              onfocusin={() => showPrefixForName(true)}
              onfocusout={() => showPrefixForName(false)}
              onChange={(e) => {
                e.target.value.trim() !== '' && changeFullNamePlaceholder('');
                changeFullName({
                  name: e.target.value.replace(
                    checkOnlyLettersAndSpacesRegex,
                    '',
                  ),
                });
              }}
            />
          </div>
        </LabelContainer>
        <LabelContainer>
          <div className='subHeading'>Customer's E-mail (Optional)</div>
          <div className='emailWrapper'>
            {prefixForEmail && (
              <span className='emailPlaceholder'>{emailPlaceholder}</span>
            )}
            <MuiInput
              label='Email'
              outlined
              inputType='text'
              inputName='email'
              inputID='email'
              elementName='Email'
              maxLength={40}
              inputValue={email}
              onfocusin={() => {
                showPrefixForEmail(true);
                setEmailError(false);
              }}
              onfocusout={() => showPrefixForEmail(false)}
              onChange={(e) => {
                e.target.value.trim() !== '' && changeEmailPlaceholder('');
                if (e.target.value.trim() === '' && e.target.value.length > 0)
                  return;
                changeEmail(e.target.value.trim());
              }}
            />
            {emailError && (
              <div className='errorText'>Please enter valid email address</div>
            )}
          </div>
        </LabelContainer>
        <BtnContainerSection>
          <SaCustomButton
            id='sa-app-btn'
            disable={
              fullName.name.trim() === '' ||
              checkOnlyLettersAndSpacesRegex.test(fullName.name)
            }
            onClick={() => {
              salesAppTracker.trackClick(
                'sa_click_ntb_share_details_submitted',
                undefined,
              );
              handleSubmitNtb();
            }}
            loading={loading}
            name={btnTxt}
            containerClass='btnContainer'
          />
        </BtnContainerSection>
      </div>
    </ShareNtbAppContainer>
  );
};

export default ShareNtbApp;



// WEBPACK FOOTER //
// ./components/salesApp/ShareNtbApp.js